import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import NodalTxnListUI from '../../../components/superUser/nodalTxn/NodalTxnListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const NodalTxnListPageUI = ({ context, errorList, accountNumber, transactionList, filteredTransactionList,
  selectedTxnId, on733Click, on441Click,
  year, month, yearList, monthList, onYearChange, onMonthChange,
  searchFilter, onSearchFilterChange, onRefreshClick,
  onCopyToClipboard, copyToClipboardText,onDownloadClick,
  onExternalClick, externalSubmitted, onCancelledClick, cancelledSubmitted,
  onUpdateRemarksClick, updateRemarksMode, onCancelRemarksClick, objectCode, objectId, selectedRemarks,
  transactionId, reconciliationStatus, nodalExtTxnTypeList,
  details, onDetailsClick
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_txn_l' topnav='transactions'
    headerText='Nodal transactions' centered={!transactionList && !errorList}
    page={accountNumber === '007105010733' ? '0733' : '4441'} dimension='w768'
  >
    {
      !transactionList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    {
      transactionList &&
      <NodalTxnListUI context={context}
        accountNumber={accountNumber}
        transactionList={filteredTransactionList}
        onRefreshClick={onRefreshClick}
        on733Click={on733Click}
        on441Click={on441Click}
        yearList={yearList}
        monthList={monthList}
        year={year}
        month={month}
        onYearChange={onYearChange}
        onMonthChange={onMonthChange}
        selectedTxnId={selectedTxnId}
        searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        onExternalClick={onExternalClick}
        externalSubmitted={externalSubmitted}
        onCancelledClick={onCancelledClick}
        cancelledSubmitted={cancelledSubmitted}
        onUpdateRemarksClick={onUpdateRemarksClick}
        updateRemarksMode={updateRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectCode={objectCode}
        objectId={objectId}
        selectedRemarks={selectedRemarks}
        transactionId={transactionId}
        reconciliationStatus={reconciliationStatus}
        nodalExtTxnTypeList={nodalExtTxnTypeList}
        details={details}
        onDetailsClick={onDetailsClick}
        onDownloadClick={onDownloadClick}
      />
    }
  </SuperUserTxnPageUI>

export default NodalTxnListPageUI
